export enum ActionType {
  INIT_WEIGHINGS_HTTP_REQUEST = 'INIT_WEIGHINGS_HTTP_REQUEST',
  END_WEIGHINGS_HTTP_REQUEST = 'END_WEIGHINGS_HTTP_REQUEST',
  SET_WEIGHINGS = 'SET_WEIGHINGS',
  ADD_WEIGHING = 'ADD_WEIGHING',
  EDIT_WEIGHING = 'EDIT_WEIGHING',
  DELETE_WEIGHING = 'DELETE_WEIGHING',
  SHOW_SUCCESS_NOTIFICATION = 'SHOW_SUCCESS_NOTIFICATION',
  SHOW_ERROR_NOTIFICATION = 'SHOW_ERROR_NOTIFICATION',
  HIDE_NOTIFICATION = 'HIDE_NOTIFICATION',
  SET_PROFILE = 'SET_PROFILE',
  AUTHENTICATE_USER = 'AUTHENTICATE_USER',
  LOGOUT_USER = 'LOGOUT_USER',
}
